import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useAdmin } from '../../context/AdminContext';
import { useAuth } from '../../AuthenticatedApp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus, faEnvelope, faUserTag, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import AdminFormModal from '../shared/AdminFormModal';
import AdminNotice from '../shared/AdminNotice';

const AddUserModal = ({ show, onClose, onUserAdded }) => {
  const [email, setEmail] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [areaId, setAreaId] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { areas, roles } = useAdmin();
  const { user } = useAuth();

  const validateForm = () => {
    const nextErrors = {};
    if (!email) nextErrors.email = 'Email zorunludur.';
    if (!selectedRole) nextErrors.role = 'Rol seçilmelidir.';
    return nextErrors;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setLoading(true);
    setErrors({});

    try {
      const selectedRoleObject = roles.find((role) => role.id === parseInt(selectedRole, 10));
      await onUserAdded({
        email,
        areaId: areaId ? parseInt(areaId, 10) : null,
        roleId: parseInt(selectedRole, 10),
        role: selectedRoleObject,
      });
      setEmail('');
      setSelectedRole('');
      setAreaId('');
      onClose();
    } catch (error) {
      setErrors({ general: error.message || 'Kullanıcı oluşturulamadı.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminFormModal
      show={show}
      onClose={onClose}
      title="Yeni Kullanıcı Ekle"
      subtitle="Davetiye e-postası gönderilecek yeni ekip üyesi oluşturun."
      icon={faUserPlus}
      notice={errors.general ? <AdminNotice tone="error" title="Kullanıcı oluşturulamadı" message={errors.general} onDismiss={() => setErrors((current) => ({ ...current, general: undefined }))} /> : null}
      footer={(
        <>
          <div className="admin-modal-footer-secondary">
            <Button variant="secondary" onClick={onClose} disabled={loading} className="modal-cancel-btn">
              İptal
            </Button>
          </div>
          <div className="admin-modal-footer-primary">
            <Button variant="primary" onClick={handleSubmit} disabled={loading} className="modal-save-btn">
              <FontAwesomeIcon icon={faUserPlus} />
              {loading ? 'Oluşturuluyor...' : 'Kullanıcı Ekle'}
            </Button>
          </div>
        </>
      )}
    >
      <Form onSubmit={handleSubmit} className="admin-form-section">
        <div className="admin-form-block">
          <div className="admin-form-block-title">
            <FontAwesomeIcon icon={faEnvelope} />
            Kullanıcı Bilgisi
          </div>
          <div className="admin-form-grid">
            <div className="admin-modal-field">
              <Form.Label>E-posta</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                className={`form-input ${errors.email ? 'error' : ''}`}
                placeholder="user@example.com"
                required
                disabled={loading}
              />
              {errors.email ? <div className="error-message">{errors.email}</div> : null}
              <div className="admin-modal-helper">Kullanıcı davet e-postası alır ve şifresini kendisi oluşturur.</div>
            </div>
            <div className="admin-modal-field">
              <Form.Label>
                <FontAwesomeIcon icon={faUserTag} className="form-icon" />
                Rol
              </Form.Label>
              <Form.Select
                value={selectedRole}
                onChange={(event) => setSelectedRole(event.target.value)}
                className={`form-input ${errors.role ? 'error' : ''}`}
                required
                disabled={loading}
              >
                <option value="">Rol Seçiniz</option>
                {roles
                  .filter((role) => !(user.userRole?.name === 'venue_admin' && (role.name === 'venue_admin' || role.name === 'venue_owner')))
                  .map((role) => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
              </Form.Select>
              {errors.role ? <div className="error-message">{errors.role}</div> : null}
            </div>
            <div className="admin-modal-field">
              <Form.Label>
                <FontAwesomeIcon icon={faMapMarkerAlt} className="form-icon" />
                Alan
              </Form.Label>
              <Form.Select value={areaId} onChange={(event) => setAreaId(event.target.value)} className="form-input" disabled={loading}>
                <option value="">Tüm alanlar</option>
                {areas.map((area) => (
                  <option key={area.id} value={area.id}>
                    {area.name}
                  </option>
                ))}
              </Form.Select>
              <div className="admin-modal-helper">Alan seçilmezse kullanıcı tüm operasyon alanlarında görev alabilir.</div>
            </div>
          </div>
        </div>
      </Form>
    </AdminFormModal>
  );
};

export default AddUserModal;
